import { useJoinStore } from '@/store/joinStore'
import type { Language } from '@/types/join'

/** Effective language for i18n calls in the join flow. Selected value if the
 *  candidate has picked one; otherwise the first language offered by the
 *  template. Defaults to 'de' if the store is empty (defensive — callers
 *  should only invoke this after the resolver has hydrated).
 */
export function useJoinEffectiveLanguage(): Language {
  return useJoinStore(
    (s) => s.selectedLanguage ?? s.resolved?.candidate.availableLanguages[0] ?? 'de',
  )
}
